import VueFacebookPage from './VueFacebookPage.vue'
import * as $ from 'jquery/dist/jquery.min.js'

// This is your plugin object. It can be exported to be used anywhere.
const VueFacebook = {
  install(Vue, appId) {
  	Vue.mixin({
      methods: {
        showFb() {
          let clicker = $('#facebook-clicker')
          if(clicker[0].style.left === '') {
            $('#hidden-fb').toggle()
            clicker.animate({left: "+=340"}, 400, () => console.log('done'))
            $('#hidden-fb').animate({left: "500px"}, 1000, () => console.log('done'))
          } else {
            clicker[0].style.left = ''
            $('#hidden-fb')[0].style.left = '-400px'
            $('#hidden-fb').toggle()
          }
        }
      },
      mounted() {
        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1&appId=${appId}&autoLogAppEvents=1`;
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
      }
    })
    Vue.component('VueFacebookPage', VueFacebookPage)
  }
}

export default VueFacebook